
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SnowFlurryEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (0.3 + layerIndex * 0.1) * 200 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const scrollY = (time * speed) % spacing;
            const sway = Math.sin(time + x * 0.01) * 30;
            
            for (let y = y1; y <= y2; y += spacing / 2) {
                const size = (1 + driftP * 3) * scale;
                
                const draw = () => {
                    ctx.beginPath();
                    ctx.arc(x + sway, y + scrollY, size, 0, Math.PI * 2);
                    ctx.fill();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
